import { render, staticRenderFns } from "./CnpjInput.vue?vue&type=template&id=1e73ebf2&scoped=true&"
import script from "./CnpjInput.vue?vue&type=script&lang=js&"
export * from "./CnpjInput.vue?vue&type=script&lang=js&"
import style0 from "./CnpjInput.vue?vue&type=style&index=0&id=1e73ebf2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e73ebf2",
  null
  
)

export default component.exports